import { toRefs, computed } from 'vue';

//
var script = {
  props: {
    id: {
      type: String,
      required: true
    },
    options: Object
  },
  setup(props) {
    const {
      options,
      id
    } = toRefs(props);
    const source = computed(() => {
      switch (options.value.id) {
        case 'spotify_track':
          return `https://open.spotify.com/embed/track/${id.value}`;
        case 'spotify_playlist':
          return `https://open.spotify.com/embed/playlist/${id.value}`;
        case 'spotify_artist':
          return `https://open.spotify.com/embed/artist/${id.value}`;
        case 'spotify_album':
          return `https://open.spotify.com/embed/album/${id.value}`;
        case 'spotify_show':
          return `https://open.spotify.com/embed/show/${id.value}`;
        case 'spotify_episode':
          return `https://open.spotify.com/embed/episode/${id.value}`;
      }
      return null;
    });
    return {
      source
    };
  }
};
export { script as default };